module.exports = __webpack_public_path__ + "media/images/main-logo-d4da592f724edd3738f322a247466add.svg";